import {reactive} from "vue";
import axios from "axios";

export default reactive({
    domain: undefined,
    newerVersionAvailable: undefined,
    versionCheckApi: undefined,
    versionTimer: undefined,
    initialize(domain) {
        this.domain = domain;
        this.versionCheckApi = axios.create();
        this.checkVersion();
        this.checkVersionTimer();
    },
    deinitialize() {
        if (this.versionTimer) clearTimeout(this.versionTimer);
    },
    checkVersion() {
        this.versionCheckApi.get("https://" + this.domain + "/version.txt").then(response => {
            if (response.data && response.data.length > 0 && response.data.length < 100) {
                if (localStorage.getItem("installedFrontendVersion")) {
                    if (localStorage.getItem("installedFrontendVersion") !== response.data) {
                        this.newerVersionAvailable = response.data;
                    }
                } else {
                    localStorage.setItem("installedFrontendVersion", response.data);
                }
            }
        });
    },
    checkVersionTimer() {
        this.versionTimer = setTimeout(() => {
            this.checkVersion();
            this.checkVersionTimer();
        }, 180000);
    },
    performUpdate() {
        if (this.newerVersionAvailable) {
            localStorage.setItem("installedFrontendVersion", this.newerVersionAvailable);
            location.reload();
            this.newerVersionAvailable = undefined;
        }
    }
});